import { render, staticRenderFns } from "./GradingPage.vue?vue&type=template&id=01e531a4&scoped=true"
import script from "./GradingPage.vue?vue&type=script&lang=js"
export * from "./GradingPage.vue?vue&type=script&lang=js"
import style0 from "./GradingPage.vue?vue&type=style&index=0&id=01e531a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e531a4",
  null
  
)

export default component.exports